import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatAccordionTogglePosition } from '@angular/material/expansion';
import { FAQList } from '../../utils/constants.helper';

@Component({
  selector: 'app-help-faq',
  templateUrl: './help-faq.component.html',
  styleUrls: ['./help-faq.component.scss'],
})
export class HelpFAQComponent {
  @Input() togglePosition!: MatAccordionTogglePosition;

  constructor(public dialogRef: MatDialogRef<HelpFAQComponent>) {}
}
